import { useMemo } from "react";

import { useClinicalReportDetailsData } from "@providers/ClinicalReportDetailsProvider";
import { ClinicalReportPageRoute } from "@routes/ClinicalReports/ClinicalReportsHelper";

export const useOrderedReportSubRoutes = () => {
  const { isReassessment } = useClinicalReportDetailsData();

  const orderedRoutes = useMemo(() => {
    const routes: ClinicalReportPageRoute[] = ["upload-files"];
    if (isReassessment) {
      routes.push("select-programming");
    }
    routes.push("report-page", "review-and-sign");
    return routes;
  }, [isReassessment]);

  return {
    orderedRoutes,
    getNextRoute: (route: ClinicalReportPageRoute) => {
      const currentIndex = orderedRoutes.indexOf(route);
      return currentIndex >= 0 && currentIndex < orderedRoutes.length - 1 ? orderedRoutes[currentIndex + 1] : null;
    },
    getPastRoute: (route: ClinicalReportPageRoute) => {
      const currentIndex = orderedRoutes.indexOf(route);
      return currentIndex > 0 ? orderedRoutes[currentIndex - 1] : "upload-files"; // ToDo: handle else to navigate back to report list page
    },
    statusFromCurrentRoute: (currentRoute: ClinicalReportPageRoute, navStepRoute: ClinicalReportPageRoute) => {
      if (currentRoute === navStepRoute) return "current";
      return orderedRoutes.indexOf(currentRoute) > orderedRoutes.indexOf(navStepRoute) ? "complete" : "upcoming";
    },
  };
};
